import React from 'react';
import { useSearchParams } from 'react-router-dom';
import EmailValidation from './EmailValidation.tsx';
import Logo from './ui/Logo.tsx';

import diana from '../assets/diana.png';
import tikkunMap from '../assets/tikkun-map.jpg';
import astralMap from '../assets/astral-map.jpg';

const MainLandingPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const purchaseId = searchParams.get('purchaseId');

  // If purchaseId is provided in the URL, show the EmailValidation component
  if (purchaseId) {
    return <EmailValidation purchaseId={purchaseId} />;
  }

  // Otherwise, show the main landing page
  return (
    <>
    <div className="container max-w-3xl bg-white mx-auto rounded-2xl">
      <div className="card p-4 md:p-8">
        <div className="header p-4">
          <Logo />
        </div>

        <div className="content">
          <div className="hero-section">
            <h2>Descubra Seu Mapa Astral</h2>
            <p>
              Desvende os segredos do seu mapa de nascimento com nossos relatórios personalizados de mapa astral. 
              Obtenha insights detalhados sobre sua personalidade, caminho de vida e influências cósmicas.
            </p>
          </div>

          <div className="features">
            <div className="feature space-y-2">
              <img src={astralMap} alt="Mapa Astral Grátis" />
              <h3>Mapa Astral Grátis</h3>
              <p>Obtenha seu mapa astral único baseado na sua hora e local de nascimento exatos</p>
            </div>
            <div className="feature space-y-2">
              <img src={tikkunMap} alt="Mapa da Alma" />
              <h3>Mapa da Alma</h3>
              <p>Interpretações abrangentes das posições planetárias e aspectos</p>
            </div>
            {/* <div className="feature">
              <h3>🎯 Orientação de Vida</h3>
              <p>Descubra seus pontos fortes, desafios e propósito de vida através da astrologia</p>
            </div> */}
          </div>

          <div className="cta-section">
            <h3 className="font-bold">Pronto para Explorar Seu Mapa Astral?</h3>
            <p>Visite nosso site principal para adquirir seu relatório personalizado de mapa astral</p>
            
            <a 
              href="https://dikaastral.com" 
              rel="noopener noreferrer"
              className="inline-block p-3 px-6 text-xs md:text-xl leading-none font-bold rounded-full bg-white text-purple-800 mt-4"
            >
              FAÇA O SEU MAPA ASTRAL GRÁTIS
            </a>
          </div>

          <div className="info-section">
            <h3>O Que Você Receberá:</h3>
            <ul>
              <li>Seu mapa astral completo</li>
              <li>Análise das posições planetárias e aspectos</li>
              <li>Interpretações das casas astrológicas</li>
              <li>Insights pessoais e orientação</li>
              <li>Análise astrológica profissional</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className='hidden xl:block fixed bottom-0 -left-10 w-1/3'>
      <img src={diana} alt="Diana" className='w-full' />
    </div>
    </>
  );
};

export default MainLandingPage; 